var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333924 0.833924C0.646343 0.521505 1.0308 0.5 1.49805 0.5L4.09961 0.5H6.73392C6.99805 0.5 7.55288 0.521504 7.86529 0.833924C8.17772 1.14634 8.17772 1.65288 7.86529 1.96529L4.6653 5.1653C4.35288 5.47772 3.84634 5.47772 3.53392 5.1653L0.333924 1.96529C0.0215045 1.65288 0.0215045 1.14634 0.333924 0.833924Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333924 0.833924C0.646343 0.521505 1.0308 0.5 1.49805 0.5L4.09961 0.5H6.73392C6.99805 0.5 7.55288 0.521504 7.86529 0.833924C8.17772 1.14634 8.17772 1.65288 7.86529 1.96529L4.6653 5.1653C4.35288 5.47772 3.84634 5.47772 3.53392 5.1653L0.333924 1.96529C0.0215045 1.65288 0.0215045 1.14634 0.333924 0.833924Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333924 0.833924C0.646343 0.521505 1.0308 0.5 1.49805 0.5L4.09961 0.5H6.73392C6.99805 0.5 7.55288 0.521504 7.86529 0.833924C8.17772 1.14634 8.17772 1.65288 7.86529 1.96529L4.6653 5.1653C4.35288 5.47772 3.84634 5.47772 3.53392 5.1653L0.333924 1.96529C0.0215045 1.65288 0.0215045 1.14634 0.333924 0.833924Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownFilled);
export default __webpack_public_path__ + "static/media/arrow-down-filled.e0a5d4da59d05e88ea3537d6e68932ba.svg";
export { ForwardRef as ReactComponent };